import { UsersDashboard } from "@/features/users";
import { createFileRoute } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../../httpClient";
import { verifyRoles } from "../../../utils/verifyRoles";

export const Route = createFileRoute("/dashboard/users/")({
  component: UsersDashboard,
  head: () => ({
    meta: [{ title: "Usuários - Backoffice Detentora Iniciador" }],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN"]),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["users"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/users");

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
